import React from 'react';
import { useTranslation } from 'react-i18next';
import { Stack } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
//own
import { createSx } from '../../../../../../../../../../utils';
import EllipsedTypography from '../../../../../../../../../Tooltip/EllipsedTypography';
import IconButton from '../../../../../../../../../IconButton';
import { Attachment } from '../../../../../../../..';
import { DialogContentProps } from '../../../..';
import { attachmentDetailsSectionStyles } from '../../../shared/styles';

const sx = createSx(attachmentDetailsSectionStyles);

const AttachmentDetailsSection = <T extends Attachment, >({ activeAttachment, handleClose, AttachmentDetails }: DialogContentProps<T>) => {
  const { t } = useTranslation();

  return (
    <Stack data-test-id='attachment-details-section' sx={sx.wrapper}>
      <Stack sx={sx.header} data-test-id='attachment-details-section-header'>
        <EllipsedTypography variant='h5' testID='attachment-name'>{activeAttachment.name}</EllipsedTypography>
        <IconButton
          title={t('close')}
          onClick={handleClose}
          data-test-id='close-attachment-details-btn'>
          <CloseIcon />
        </IconButton>
      </Stack>
      {AttachmentDetails && <AttachmentDetails attachment={activeAttachment} />}
    </Stack>
  );
};

export default AttachmentDetailsSection;